import React, { useState } from "react";
import { isMobile, isTablet } from "react-device-detect";
import Button from '@material-ui/core/Button';
import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import { KeyboardDatePicker, MuiPickersUtilsProvider, } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

import * as RemindersApi from '../../../Common/Apis/RemindersApi';
import ReminderHistoryListItem from "./ListItem";
import ContentsWrapper from '../../../Public/Wrapper/ContentsWrapper';
import { useSpinner } from '../../../../core/contexts/SpinnerContext';
import Header from '../../../Public/Header/Header';

const useStyles = makeStyles((theme) => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '100%',
  },
}));

const ReminderHistory = () => {

  const [listData, setListData] = useState();
  const [searchDateFrom, setsearchDateFrom] = useState<Date | null>(new Date());
  const [searchDateTo, setsearchDateTo] = useState<Date | null>(new Date());
  const [pageSize, setpageSize] = useState((isMobile && !isTablet) ? 10 : 100);
  const [pageNo, setpageNo] = useState(1);

  const { setSpinner } = useSpinner();
  const muiClasses = useStyles();



  const pageSizeChanged = (i: number) => {
    setpageSize(i);
    setpageNo(1);
    getList(1, i);
  };

  const pageNoChanged = (i: number) => {
    setpageNo(i);
    getList(i, pageSize);
  };


  const getList = async (_pageNo: number, _pageSize: number) => {

    setSpinner(true);

    try {

      const queryStartDate = moment(searchDateFrom).format('YYYY-MM-DD 00:00:00');
      const queryEndDate = moment(searchDateTo).format('YYYY-MM-DD 23:59:59');
      const resData = await RemindersApi.getReminderHistoryList(queryStartDate, queryEndDate, _pageNo, _pageSize);

      setListData(resData);


    } catch (err) {
      console.log('err', err);
    }

    setSpinner(false);
  };

  const clickedGetReport = async (e: any) => {
    e.preventDefault();

    getList(pageNo, pageSize);
  };


  return (
    <ContentsWrapper header={<Header title="Reminder History" />}>
      <div className="row no-gutters">
        <div className="col-lg-12  mt-3">
          <div className="tab-content" id="myTabContent">
            <div className="card">
              <div className="card-body">
                <form onSubmit={clickedGetReport}>
                  <div className="row ">
                    <div className="col-lg-2">
                      <div className="form-group">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            variant="inline"
                            value={searchDateFrom}
                            onChange={setsearchDateFrom}
                            autoOk={true}
                            format="dd/MM/yyyy"
                            className={muiClasses.textField}
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <div className="form-group">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            variant="inline"
                            value={searchDateTo}
                            onChange={setsearchDateTo}
                            autoOk={true}
                            format="dd/MM/yyyy"
                            className={muiClasses.textField}
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                    </div>
                    <div className="col-lg-5">
                      <div className="form-group">
                        <Button
                          type="submit"
                          className=" ml-3"
                          style={{ fontWeight: '600' }}
                          variant="contained"
                          color="primary"
                        >
                          Search
                        </Button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12  mt-3">
          <div className="tab-content" id="myTabContent">
            {listData && <ReminderHistoryListItem
              items={listData}
              pageSizeChanged={pageSizeChanged}
              pageNoChanged={pageNoChanged}
            />}
          </div>
        </div>
      </div>

    </ContentsWrapper>
  );

};


export default ReminderHistory;